import React from "react";

const SocialMedia = () => {
  return (
    <div className="share-buttons" aria-label="Share this article">
        <a
        href="#!"
        className="share-btn"
        aria-label="Share on Facebook"
        >
        <i className="fab fa-facebook-f" aria-hidden="true"></i>
        </a>
        <a
        href="#!"
        className="share-btn"
        aria-label="Share on Twitter"
        >
        <i className="fab fa-twitter" aria-hidden="true"></i>
        </a>
        <a
        href="#!"
        className="share-btn"
        aria-label="Share on LinkedIn"
        >
        <i className="fab fa-linkedin-in" aria-hidden="true"></i>
        </a>
        <a
        href="#!"
        className="share-btn"
        aria-label="Share via Email"
        >
        <i className="fas fa-envelope" aria-hidden="true"></i>
        </a>
    </div>
  );
};

export default SocialMedia;